FrameModules.add('PatrolThresholdFrameModule', function() {
   when($('patrolThreshold'), function(form) {
      var save = $E('#patrolThreshold button');
      var input = form.getElement('input.value');

      var type = form.type.value;
      // The maximum value the user is allowed to set
      var max_allowed = form.max_allowed.value.toInt();
      // The maximum value anyone can set
      var max_displayed = form.max_displayed.value.toInt();
      // The value that gets set when "infinite" is submitted
      var infinite = form.infinite.value.toInt();

      var infChar = '∞';
      var initial_value = input.value === infChar ? infinite : input.value.toInt();

      var slider = new RangeSlider($('patrolSlider'), {
         type: 'single',
         range: [0, max_allowed],
         position: [initial_value],
         onChange: function(step) {
            input.value = step === max_displayed ? infChar : step;
         }.bind(this),
         onComplete: function(step) {
            save.disabled = false;
         }.bind(this),
      });

      input.addEvent('focus', function() {
         save.disabled = false;
      });

      form.addEvent('submit', function(ev) {
         ev.stop();

         var docid = this.docid.value;
         var threshold = input.value === infChar ? 'inf' : input.value;

         new Request.AjaxIO('saveThreshold', {
            onSuccess: function(response) {
               this.submitButton.blur();
               input.blur();

               if (response == 'inf' || response >= max_allowed) {
                  slider.set(max_allowed);
                  input.value = infChar;
               } else {
                  slider.set(response);
                  input.value = response;
               }

               save.disabled = true;
            }.bind(this),

            // TODO: set type programatically
         }).send(type, docid, threshold);
      });

      save.disabled = true;
   });
});
